import ListDeposits from '../../UI/Deposits/ListDeposits';
import { useParams } from 'react-router';
import { Banner, Button, LegacyCard, Page, LegacyStack } from '@shopify/polaris';
import { useContext, useRef, useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { postNewDeposit } from '../../../services/depositsService';
import { NewDepositModal } from '../../UI/Deposits/NewDepositModal';
import { checkPermission } from '../../../services/permissionsService';

const Deposits = (props) => {
  const { page } = useParams();
  const [, dispatchToast] = useContext(ToastContext);
  const listDeposits = useRef();
  const [multiMode, setMultiMode] = useState(false);

  const createNewDeposit = (signUpForm) => {
    return postNewDeposit(signUpForm)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        listDeposits.current.last({ new: true });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
        throw new Error(e.response.data);
      });
  };
  const admin = JSON.parse(localStorage.getItem('user')).user.admin;

  return <>
    <Page
      title="Depósitos"
      primaryAction={
        <LegacyStack>
          {checkPermission('DEPOSIT:READ') && (
            <Button pressed={multiMode} onClick={() => setMultiMode((m) => !m)}>
              Multidepósito
            </Button>
          )}
          {checkPermission('DEPOSIT:READ') && (
            <Button onClick={() => (window.location.href = '/losses')}>Ver pérdidas (todos)</Button>
          )}
          {checkPermission('ADMIN') && (
            <Button onClick={() => (window.location.href = '/files/inventories/eph')}>
              Inventario desde Fichero EPH
            </Button>
          )}
          {checkPermission('DEPOSIT:CREATE') && (
            <NewDepositModal disable={!admin} onAddDeposit={(e) => createNewDeposit(e)} />
          )}
        </LegacyStack>
      }
      divider
    >
      {multiMode && (
        <div style={{ marginBottom: '1rem' }}>
          <Banner
            title="Modo multidepósito"
            status="info"
            onDismiss={() => setMultiMode(false)}
            action={{ content: 'Salir del modo', onAction: () => setMultiMode(false) }}
          >
            <p>Marca los depósitos que quieras y pulsa «Ver stock conjunto» para consultar su stock en una sola vista.</p>
          </Banner>
        </div>
      )}
      <LegacyCard>
        <ListDeposits ref={listDeposits} page={page || 1} multiMode={multiMode} />
      </LegacyCard>
    </Page>
  </>;
};

export default Deposits;
